module.exports = __webpack_public_path__ + "static/img/hero-bg.dde67246.webp";